import firebase from "firebase/app";
import 'firebase/firestore';
const firestore = firebase.firestore;

const COLLECTION_COMPANIES = process.env.VUE_APP_COLLECTION_COMPANIES;
const COLLECTION_COMMENTS = process.env.VUE_APP_COLLECTION_COMMENTS;
const COLLECTION_UTILS = process.env.VUE_APP_COLLECTION_UTILS;

export default {
    namespaced: true,
    state: {
        companiesUtils: null,
        commentsUtils: null,
        cards: []
    },
    getters: {
        companiesUtils: state => state.companiesUtils,
        commentsUtils: state => state.commentsUtils,
        cards: state => state.cards
    },
    mutations: {
        SET_COMMENTS_UTILS(state, value) {
            state.commentsUtils = value;
        },
        SET_COMMENTS_UTILS_PROP(state, payload) {
            state.commentsUtils[payload.prop] = state.commentsUtils[payload.prop] + payload.value;
        },
        SET_COMPANIES_UTILS(state, value) {
            state.companiesUtils = value;
        },
        SET_CARDS(state, value) {
            state.cards = value;
        },
        SET_COMPANIES_UTILS_PROP(state, payload) {
            state.companiesUtils[payload.prop] = payload.value;
        }
    },
    actions: {
        async getCommentsUtils({commit}) {
            const commentUtils = await firestore().collection(COLLECTION_UTILS).doc(COLLECTION_COMMENTS).get()
                .then(doc => doc.data());
            commit('SET_COMMENTS_UTILS', commentUtils);
        },
        async setCommentsUtils({commit}, value) {
            await firebase.firestore().collection(COLLECTION_UTILS).doc(COLLECTION_COMMENTS)
                .set(value);
            commit('SET_COMMENTS_UTILS', value);
        },
        async getCompaniesUtils({commit}) {
            const companiesUtils = await firestore().collection(COLLECTION_UTILS).doc(COLLECTION_COMPANIES).get()
                .then(doc => doc.data());
            commit('SET_COMPANIES_UTILS', companiesUtils);

            const shuffled = companiesUtils.searchableCompanies.sort(() => 0.5 - Math.random());
            const red = shuffled.find(company =>  company.score <= 3);
            const yellow = shuffled.find(company => 4 <= company.score && company.score <= 7);
            const green = shuffled.find(company => company.score >= 8);
            const cards = [red, yellow, green].filter(Boolean);

            commit('SET_CARDS', cards.length === 3 ? cards : shuffled.slice(0, 3));
        },
        async setCompaniesUtils({commit}, value) {
            await firebase.firestore().collection(process.env.VUE_APP_COLLECTION_UTILS).doc(COLLECTION_COMPANIES)
                .set(value);
            commit('SET_COMPANIES_UTILS', value);
        },
        async addCompaniesUtils({commit, state}, prop) {
            await firestore().collection(process.env.VUE_APP_COLLECTION_UTILS)
                .doc(process.env.VUE_APP_COLLECTION_COMPANIES)
                .update({ length: state.companiesUtils[prop] + 1 });
            commit('SET_COMPANIES_UTILS_PROP', {prop, value: state.companiesUtils[prop] + 1});
        },
        async removeCompaniesUtils({commit, state}, prop) {
            await firestore().collection(process.env.VUE_APP_COLLECTION_UTILS)
                .doc(process.env.VUE_APP_COLLECTION_COMPANIES)
                .update({ length: state.companiesUtils[prop] - 1 });
            commit('SET_COMPANIES_UTILS_PROP', {prop, value: state.companiesUtils[prop] - 1});
        },
        async updateCompaniesUtilsProp({commit, state}, payload) {
            const { prop, value, action } = payload;
            let finalPayload = null;

            switch(action) {
            case 'add':
                finalPayload = [...state.companiesUtils[prop], value].sort();
                break;
            case 'delete':
                finalPayload = state.companiesUtils[prop].filter(item => item !== value);
                break;
            }
            await firestore().collection(process.env.VUE_APP_COLLECTION_UTILS)
                .doc(process.env.VUE_APP_COLLECTION_COMPANIES)
                .update({ [prop]: finalPayload });
            commit('SET_COMPANIES_UTILS_PROP', { prop, value: finalPayload });
        },
        async setAdConfig({commit}, payload) {
            const {sidebarAdUrl, sidebarAdImg} = payload;
            await firestore().collection(COLLECTION_UTILS).doc(COLLECTION_COMPANIES)
                .update({ sidebarAdUrl, sidebarAdImg });
            commit('SET_COMPANIES_UTILS_PROP', { prop: 'sidebarAdUrl', value: sidebarAdUrl });
            commit('SET_COMPANIES_UTILS_PROP', { prop: 'sidebarAdImg', value: sidebarAdImg });
        }
    }
}
